import { render, staticRenderFns } from "./WorkflowList.vue?vue&type=template&id=7241ec26&scoped=true&"
import script from "./WorkflowList.vue?vue&type=script&lang=ts&"
export * from "./WorkflowList.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowList.vue?vue&type=style&index=0&id=7241ec26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7241ec26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
